export default "__VITE_ASSET__ql7dp3QE__"